import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IBrandCollectionSectionProps {
  $bgColor?: string;
  $textColor?: string;
  $pointColor?: string;
  $emphasisTextColor?: string;
  $rowsMobile?: number;
  $rowsPc?: number;
}

export const BrandCollectionSection = styled.div<IBrandCollectionSectionProps>`
  position: relative;
  padding: 12px 0 32px 0;
  background: #fff;

  ${({ $bgColor, $textColor, $pointColor, $emphasisTextColor }) =>
    $bgColor &&
    css`
      background: ${$bgColor};

      .category-tab {
        .menubar-swiper {
          background: ${$bgColor} !important;
        }

        .menubar-item {
          .area-click {
            color: ${$textColor};
          }

          &.active .area-click {
            color: ${$emphasisTextColor};
            background: ${$pointColor};
          }
        }
      }

      .brand-item {
        border: 1px solid #eee !important;
        background: rgba(255, 255, 255, 0.6) !important;

        .tag {
          color: ${$emphasisTextColor} !important;
          background-color: ${$pointColor} !important;
        }
      }

      @media ${({ theme }) => theme.media.pc} {
        .category-tab {
          .swiper-slide .menubar-item {
            .area-click {
              color: ${$textColor};
              background-color: transparent !important;
            }

            &.active .area-click {
              color: ${$emphasisTextColor};
              border: none;
              background: ${$pointColor} !important;
            }
          }

          .btn-folding {
            &:after {
              background: linear-gradient(
                270deg,
                ${$bgColor} 29.17%,
                rgba(255, 255, 255, 0) 100%
              );
            }
          }
        }
      }
    `}

  &.bg-type-black {
    background: #000;

    .category-tab .menubar-swiper {
      background-color: #000;
    }

    .brand-item {
      background-color: #1a1a1a;
      border-color: #333;

      .img {
        &:after {
          display: none;
        }
      }

      .brand-name-kr {
        color: #fff;
      }

      .tag {
        color: #000;
        background-color: #fff;
      }
    }
  }

  .img-wrap .img {
    height: 100%;
  }

  .category-tab {
    height: 57px;
    padding: 0;
    background-color: transparent;

    .menubar-swiper {
      height: 57px;
      padding: 12px 0;
    }
  }

  .items-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-content: start;
    gap: 8px;
    min-height: 377px;
    padding: 0 20px;
  }

  .brand-item {
    ${mixin.flex({ justify: 'flex-start' })};
    column-gap: 8px;
    position: relative;
    padding: 10px;
    border: 1px solid #eee;
    border-radius: 1px;
    text-align: left;
    background: #fff;

    .img {
      flex-shrink: 0;
      width: 47px;
      height: 47px;
      border-radius: 1px;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.03);
      }
    }

    .text-wrap {
      ${mixin.flex({
        direction: 'column',
        align: 'flex-start',
        justify: 'center',
      })};
      min-width: 0;
    }

    .text {
      line-height: 130%;
      ${mixin.ellipsis(1)};
    }

    .brand-name-kr {
      font-size: 14px;
      font-weight: 600;
      color: #000;
    }

    .brand-name-en {
      font-size: 12px;
      color: #777;
    }

    .tag {
      position: absolute;
      top: -3px;
      right: -2px;
      line-height: 130%;
      padding: 1px 4px;
      font-size: 9px;
      font-weight: 600;
      color: #fff;
      background-color: #000;
      border-radius: 100px;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('12 0 32 0')};

    .category-tab {
      height: ${mixin.pxToVw('57')};

      .menubar-swiper {
        height: ${mixin.pxToVw('57')};
        padding: ${mixin.pxToVw('12 0')};
      }
    }

    .items-grid {
      gap: ${mixin.pxToVw('8')};
      min-height: ${mixin.pxToVw('377')};
      padding: ${mixin.pxToVw('0 20')};
    }

    .brand-item {
      column-gap: ${mixin.pxToVw('8')};
      padding: ${mixin.pxToVw('10')};

      .img {
        width: ${mixin.pxToVw('47')};
        height: ${mixin.pxToVw('47')};
      }

      .brand-name-kr {
        font-size: ${mixin.pxToVw('14')};
      }

      .brand-name-en {
        font-size: ${mixin.pxToVw('12')};
      }

      .tag {
        top: ${mixin.pxToVw('-3')};
        right: ${mixin.pxToVw('-2')};
        padding: ${mixin.pxToVw('1 4')};
        font-size: ${mixin.pxToVw('9')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 20px 0 65px 0;

    &.bg-type-black {
      .category-tab .menubar-swiper {
        .menubar-item {
          .area-click {
            color: #fff;
            border: 1px solid #333;
            background-color: #000;
          }

          &.active .area-click {
            color: #000;
            border: none;
            background-color: #fff;
          }
        }
      }

      .btn-folding {
        &:after {
          background: linear-gradient(
            270deg,
            #000 29.17%,
            rgba(255, 255, 255, 0) 100%
          );
        }

        svg path {
          fill: #fff;
        }
      }
    }

    .category-tab {
      height: auto;
      min-height: 86px;
      margin: 0px auto;
      padding: 0;

      .fold-menubar {
        .menubar-swiper {
          width: 1440px;
          height: auto;
          padding: 20px 125px 20px 57px;
        }

        .btn-folding {
          top: 22px;
          right: 65px;
          z-index: 11;
        }
      }

      .swiper-slide {
        margin-right: 12px;

        .menubar-item .area-click {
          height: 48px;
          padding: 0 30px;
          border: 1px solid rgba(0, 0, 0, 0.1);
          background-color: #fff;
        }
      }
    }

    .items-grid {
      grid-template-columns: repeat(4, 1fr);
      gap: 18px;
      min-height: 300px;
      padding: 0 57px;
    }

    .brand-item {
      cursor: pointer;

      .img {
        width: 66px;
        padding-bottom: 22.3%;
      }

      .brand-name-kr {
        font-size: 18px;
      }

      .brand-name-en {
        font-size: 15px;
      }

      .tag {
        top: -6px;
        right: -6px;
        padding: 2px 8px;
        font-size: 13px;
        font-weight: 500;
      }
    }
  }
`;
